import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Select,
  Box,
  Flex,
  Image,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  Textarea,
  Checkbox,
  useDisclosure,
} from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "axios";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import React, { useState, useEffect } from "react";
import WineTypeModal from "./wineTypeModal";
import { CiCirclePlus } from "react-icons/ci";
import { FaPlus } from "react-icons/fa";

const WineRegister = () => {
  // const [data1, setData1] = useState(new Date());
  // console.log(data1.toDateString());
  // const [data2, setData2] = useState(new Date());
  // console.log(data2.toDateString());
  // const [total, setTotal] = useState(0);
  // const [advance, setAdvance] = useState(0);
  //let dueAmount = 0;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [type, setType] = useState([]);
  const [dueAmount, setDueAmount] = useState(0);
  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState([]);
  const customerId = localStorage.getItem("customerId");
  const handlePost = async () => {
    try {
      setUploading(true);

      if (!selectedFile) {
        toast.error("Please select a file to upload.");
        return;
      }

      const formData = new FormData();
      formData.append("image", selectedFile); // Ensure 'image' matches the backend field name

      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/upload", // Corrected URL
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const data = response.data;

      // Update state with uploaded image URL
      setImageURL(data.filename); // Adjust based on backend response
      toast.success("Image uploaded successfully");
      console.log(data, "Upload response");
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };
  const handleOpen = () => {
    onOpen();
  };
  console.log(imageURL, "imageURL");
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getCategoryData/${customerId}`,
      );
      setData(response.data.category);
      console.log(response.data.category);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const fetchTypeData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getWineTypeData/${customerId}`,
      );
      //  console.log(response.data.type,'type')
      setType(response.data.type);
    } catch (error) {
      console.error(error.message);
    }
  };
  console.log(type, "type");
  useEffect(() => {
    fetchData();
    fetchTypeData();
  }, [customerId]);

  const [formData, setFormData] = useState({
    itemCode: "",
    code: "",
    name: "",
    category: "",
    brand: "",
    packing: "",
    mrp: 0,
    purchaseRate: 0,
    acRate: 0,
    acHalfRate: 0,
    nonAcRate: 0,
    nonAcHalfRate: 0,
    netRate: 0,
    closingStock: 0,
    stockMl: 0,
    itemType: "",
    itemPhoto: "",
    halfPlate: false,
    needBtlRate: false,
  });
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const validateForm = () => {
    const requiredFields = [
      "itemCode",
      "code",
      "name",
      "category",
      "brand",
      "packing",
      "mrp",
      "purchaseRate",

      "itemType",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };
  const handleSubmit = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    e.preventDefault();
    // Here you can send formData to your backend server or process it further
    console.log("Form submitted with data:", formData);

    // Reset form after submission
    setFormData({
      itemCode: formData.itemCode,
      code: formData.code,
      name: formData.name,
      category: formData.category,
      brand: formData.brand,
      packing: formData.packing,
      mrp: formData.mrp,
      purchaseRate: formData.purchaseRate,
      acRate: formData.acRate ? formData.acRate : 0,
      acHalfRate: formData.acHalfRate,
      nonAcRate: formData.nonAcRate,
      nonAcHalfRate: formData.nonAcHalfRate,
      netRate: formData.netRate,
      closingStock: formData.closingStock,
      stockMl: formData.stockMl,
      itemType: formData.itemType,

      itemPhoto: imageURL,
      halfPlate: formData.halfPlate,
      needBtlRate: formData.needBtlRate,
    });
  };
  const save = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/api/wineRegister",
        {
          customerId: customerId,
          data: formData,
        },
      );
      console.log("Data Submitted: ", response.data);
      toast.success(response.data.message);
      setFormData({
        itemCode: "",
        code: "",
        name: "",
        category: "",
        brand: "",
        packing: "",
        mrp: 0,
        purchaseRate: 0,
        acRate: 0,
        acHalfRate: 0,
        nonAcRate: 0,
        nonAcHalfRate: 0,
        netRate: 0,
        closingStock: 0,
        stockMl: 0,
        itemType: "",
        itemPhoto: "",
        halfPlate: false,
        needBtlRate: false,
      });
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <Box
      bg="#f7f7f7"
      p="4"
      color="black"
      width="full"
      height="90vh"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <WineTypeModal
        onOpen={onOpen}
        isOpen={isOpen}
        onClose={onClose}
        customerId={customerId}
      />

      <FormControl isRequired onSubmit={handleSubmit}>
        <Box overflowY="auto" maxH="calc(100vh - 100px)" pr={2}>
          <SimpleGrid columns={3} spacing={4}>
            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Item Code
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Item Code"
                border="1px solid #ffe4d9"
                name="itemCode"
                value={formData.itemCode}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Short Code
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Short Code"
                border="1px solid #ffe4d9"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Item Name
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Item Name"
                border="1px solid #ffe4d9"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Category
              </FormLabel>
              <Select
                bg="#FAFAFA"
                placeholder="Category"
                border="1px solid #ffe4d9"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                size="sm"
              >
                {data?.map((category, index) => (
                  <option key={index} value={category.categoryName}>
                    {category.categoryName}
                  </option>
                ))}
              </Select>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Brand Name
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Brand Name"
                border="1px solid #ffe4d9"
                name="brand"
                value={formData.brand}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Packing
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Packing"
                border="1px solid #ffe4d9"
                name="packing"
                value={formData.packing}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                MRP
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="MRP"
                border="1px solid #ffe4d9"
                name="mrp"
                value={formData.mrp}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                BTL Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="BTL Rate"
                border="1px solid #ffe4d9"
                name="purchaseRate"
                value={formData.purchaseRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0">Half Peg Available?</FormLabel>
              <Checkbox
                onChange={handleCheckboxChange}
                name="halfPlate"
                isChecked={formData.halfPlate}
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0">BTL Rate?</FormLabel>
              <Checkbox
                onChange={handleCheckboxChange}
                name="needBtlRate"
                isChecked={formData.needBtlRate}
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="120px">
                AC Full Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="AC Full Rate"
                border="1px solid #ffe4d9"
                name="acRate"
                value={formData.acRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            {formData.halfPlate && (
              <Box
                display="flex"
                alignItems="center"
                boxShadow="md"
                borderRadius="8px"
                bg="white"
                p={3}
              >
                <FormLabel mb="0" minW="120px">
                  AC Half Rate
                </FormLabel>
                <Input
                  bg="#FAFAFA"
                  placeholder="AC Half Rate"
                  border="1px solid #ffe4d9"
                  name="acHalfRate"
                  value={formData.acHalfRate}
                  onChange={handleInputChange}
                  size="sm"
                />
              </Box>
            )}

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="140px">
                Non-AC Full Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Non-AC Full"
                border="1px solid #ffe4d9"
                name="nonAcRate"
                value={formData.nonAcRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            {formData.halfPlate && (
              <Box
                display="flex"
                alignItems="center"
                boxShadow="md"
                borderRadius="8px"
                bg="white"
                p={3}
              >
                <FormLabel mb="0" minW="140px">
                  Non-AC Half Rate
                </FormLabel>
                <Input
                  bg="#FAFAFA"
                  placeholder="Non-AC Half"
                  border="1px solid #ffe4d9"
                  name="nonAcHalfRate"
                  value={formData.nonAcHalfRate}
                  onChange={handleInputChange}
                  size="sm"
                />
              </Box>
            )}

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Net Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Net Rate"
                border="1px solid #ffe4d9"
                name="netRate"
                value={formData.netRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="120px">
                Closing Stock
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Closing Stock"
                border="1px solid #ffe4d9"
                name="closingStock"
                value={formData.closingStock}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Stock ML
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Stock ML"
                border="1px solid #ffe4d9"
                name="stockMl"
                value={formData.stockMl}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Item Type
              </FormLabel>
              <Select
                bg="#FAFAFA"
                placeholder="Item Type"
                border="1px solid #ffe4d9"
                name="itemType"
                value={formData.itemType}
                onChange={handleInputChange}
                size="sm"
              >
                {type?.map((data, index) => (
                  <option key={data._id} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </Select>
              <Button ml={2} size="sm" colorScheme="blue" onClick={handleOpen}>
                <FaPlus />
              </Button>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Item Photo
              </FormLabel>
              <Input
                type="file"
                bg="#FAFAFA"
                border="1px solid #ffe4d9"
                onChange={handleFileChange}
                size="sm"
              />
              <Button
                ml={2}
                size="sm"
                variant="solid"
                onClick={handlePost}
                isLoading={uploading}
              >
                {uploading ? "Uploading" : "Upload"}
              </Button>
            </Box>
          </SimpleGrid>
        </Box>

        <Box mt={3} pb={2} display="flex" justifyContent="flex-end" gap={3}>
          <Button
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={save}
          >
            Save
          </Button>
        </Box>
      </FormControl>
    </Box>
  );
};

export default WineRegister;
